import React from "react";

const ProductBusinessCard = ({ product }) => {
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">BUSINESS INFORMATION</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <strong>Owner:</strong> {product.user?.name || '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Business Name:</strong> {product.user?.business_name || '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Category:</strong> {product.category_details?.name || '-'}
                    </div>
                    <div className="col-md-3">
                        <strong>Sub Category:</strong> {product.subcategory_details?.name || '-'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Is Featured:</strong> {product.is_featured === 1 ? ' Yes' : 'No'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Is Approved:</strong> {product.is_approved === 1 ? ' Approved' : ' Pending'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Is Active:</strong> {product.is_active === 1 ? 'Yes' : 'No'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductBusinessCard;